export default __webpack_public_path__ + "static/media/Work_Scheduler.ac2f1c8d.png";